import IMG from "/images/bg.png";
import Header from "./Header";
import MAIN_IMG from "/images/main-img.png"
import { Link } from "react-scroll";
const MainSection = () => {
  console.log(IMG)
  return (
   <div className="relative lg:h-screen">
  <div
    className="absolute inset-0 bg-center bg-color opacity-6 bg-gray-300"
    style={{ backgroundImage: `url(${IMG})` }}> 
    </div>

    <Header />
  
  <div className="relative lg:flex lg:justify-center px-5 font-montserrat">
   <div className="lg:w-10/12 lg:grid lg:grid-cols-12 py-6 lg:py-10  place-items-center">

  {/* IMAGE SECTION */}
  <div className="col-span-6 order-1 lg:order-2">
    <img src={MAIN_IMG} className="w-48 lg:w-sm mt-8 lg:mt-0" />
  </div>

  {/* TEXT SECTION */}
  <div className="col-span-6 flex flex-col gap-1 lg:gap-4 order-2 lg:order-1">
    <h1 className="text-2xl lg:text-4xl font-bold leading-7 lg:leading-10">
      Macro Pathways | Early Exploration for Nonclinical & Nondirect Practice
    </h1>
    <p className="text-sm lg:text-base text-dark-gray font-medium">
           Expanding visibility and early readiness for nonclinical and nondirect social work pathways through curated examples and accessible exploratory tools.

    </p>

    <div className="mt-3 lg:mt-0">
      <button className="bg-primary text-white font-semibold text-xs lg:text-base py-3 px-10 rounded-md shadow-md hover:cursor-pointer hover:bg-primary/90 hover:shadow-sm">
         <Link to="connected" smooth={true} duration={500}>Join Email List</Link>
       
      </button>
      <button className="bg-light-olive text-dark-gray text-xs lg:text-base py-3 px-10 rounded-md font-semibold ml-4 shadow-md hover:cursor-pointer hover:bg-light-olive/90 hover:shadow-sm">
            <Link to="contact" smooth={true} duration={500}>Contact</Link>
      </button>
    </div>
  </div>

</div>

  </div>

</div>

  );
};

export default MainSection;
